var map = {
	"./5stars": 32543,
	"./5stars.svg": 32543,
	"./FB_on_sale_tag": 42227,
	"./FB_on_sale_tag.jpg": 42227,
	"./FB_on_sale_tag_2x": 28714,
	"./FB_on_sale_tag_2x.jpg": 28714,
	"./affirm_logo": 3332,
	"./affirm_logo.svg": 3332,
	"./arrow-dark-transparent": 31638,
	"./arrow-dark-transparent.svg": 31638,
	"./arrow-white-transparent": 26903,
	"./arrow-white-transparent.svg": 26903,
	"./arrow_bg_gray": 9742,
	"./arrow_bg_gray.svg": 9742,
	"./arrow_bg_light": 49829,
	"./arrow_bg_light.svg": 49829,
	"./arrow_bg_lightgray": 39220,
	"./arrow_bg_lightgray.svg": 39220,
	"./arrow_bg_pink": 4959,
	"./arrow_bg_pink.svg": 4959,
	"./arrow_left": 24210,
	"./arrow_left.svg": 24210,
	"./arrow_left_dark": 82745,
	"./arrow_left_dark.svg": 82745,
	"./arrow_left_white": 15524,
	"./arrow_left_white.svg": 15524,
	"./arrow_right": 93609,
	"./arrow_right.svg": 93609,
	"./arrow_right_dark": 37584,
	"./arrow_right_dark.svg": 37584,
	"./arrow_right_white": 95347,
	"./arrow_right_white.svg": 95347,
	"./arrow_whitebg_left": 63991,
	"./arrow_whitebg_left.svg": 63991,
	"./arrow_whitebg_right": 94066,
	"./arrow_whitebg_right.svg": 94066,
	"./badge-corner": 82726,
	"./badge-corner.svg": 82726,
	"./best-seller": 3591,
	"./best-seller.svg": 3591,
	"./bow": 40397,
	"./bow.svg": 40397,
	"./bread_icon": 31506,
	"./bread_icon.png": 31506,
	"./button_fb_continue": 15382,
	"./button_fb_continue.svg": 15382,
	"./cart": 99361,
	"./cart.svg": 99361,
	"./cart_black": 30709,
	"./cart_black.svg": 30709,
	"./cart_blue": 94136,
	"./cart_blue.svg": 94136,
	"./cc/amex_48": 81179,
	"./cc/amex_48.png": 81179,
	"./cc/discover_48": 16891,
	"./cc/discover_48.png": 16891,
	"./cc/master_48": 95618,
	"./cc/master_48.png": 95618,
	"./cc/paypal_48": 52355,
	"./cc/paypal_48.png": 52355,
	"./cc/visa_48": 75849,
	"./cc/visa_48.png": 75849,
	"./checkmark": 27106,
	"./checkmark.svg": 27106,
	"./checkout_countries/flag_au": 47065,
	"./checkout_countries/flag_au.jpg": 47065,
	"./checkout_countries/flag_ca": 60255,
	"./checkout_countries/flag_ca.jpg": 60255,
	"./checkout_countries/flag_eu": 18493,
	"./checkout_countries/flag_eu.jpg": 18493,
	"./checkout_countries/flag_gb": 45468,
	"./checkout_countries/flag_gb.jpg": 45468,
	"./checkout_countries/flag_us": 82627,
	"./checkout_countries/flag_us.jpg": 82627,
	"./close_black_thin": 16021,
	"./close_black_thin.svg": 16021,
	"./doublehearts": 17459,
	"./doublehearts.svg": 17459,
	"./doublehearts_bold": 33391,
	"./doublehearts_bold.svg": 33391,
	"./doublehearts_bold_black": 91427,
	"./doublehearts_bold_black.svg": 91427,
	"./doublehearts_pink": 90466,
	"./doublehearts_pink.svg": 90466,
	"./doublehearts_sale": 80875,
	"./doublehearts_sale.svg": 80875,
	"./dropdown-arrow": 42944,
	"./dropdown-arrow.svg": 42944,
	"./envelop-icon": 51996,
	"./envelop-icon.svg": 51996,
	"./extend_icon": 65601,
	"./extend_icon.svg": 65601,
	"./facebook": 1384,
	"./facebook.png": 1384,
	"./facebook_like": 73047,
	"./facebook_like.svg": 73047,
	"./filter_icon_blue": 65410,
	"./filter_icon_blue.svg": 65410,
	"./filter_icon_dark_purple": 89031,
	"./filter_icon_dark_purple.svg": 89031,
	"./flags/rd/canada": 44658,
	"./flags/rd/canada.svg": 44658,
	"./flip": 38990,
	"./flip.svg": 38990,
	"./generic_loading": 43055,
	"./generic_loading.gif": 43055,
	"./gift_primary_purple": 27719,
	"./gift_primary_purple.svg": 27719,
	"./hamburger": 13324,
	"./hamburger.svg": 13324,
	"./heart-clicked-v4": 26732,
	"./heart-clicked-v4.svg": 26732,
	"./heart-unclicked-v4": 70961,
	"./heart-unclicked-v4.svg": 70961,
	"./heart_filled_pink": 13807,
	"./heart_filled_pink.svg": 13807,
	"./heart_outline_black": 6726,
	"./heart_outline_black.svg": 6726,
	"./jewlr": 81841,
	"./jewlr-logo": 14020,
	"./jewlr-logo.png": 14020,
	"./jewlr.gif": 81841,
	"./jewlr_diamond": 71647,
	"./jewlr_diamond.jpg": 9347,
	"./jewlr_diamond.svg": 71647,
	"./jwl_diamond_blue": 38106,
	"./jwl_diamond_blue.svg": 38106,
	"./jwl_diamond_white": 83617,
	"./jwl_diamond_white.svg": 83617,
	"./loading_icon": 33983,
	"./loading_icon.gif": 33983,
	"./loading_iconA": 94584,
	"./loading_iconA.gif": 94584,
	"./made_in_ca": 12797,
	"./made_in_ca.svg": 12797,
	"./made_in_ca_white": 90552,
	"./made_in_ca_white.png": 90552,
	"./made_in_ca_white.svg": 21719,
	"./made_in_ca_white_desktop": 74762,
	"./made_in_ca_white_desktop.svg": 74762,
	"./made_in_ca_white_for_red_background": 85466,
	"./made_in_ca_white_for_red_background.svg": 85466,
	"./made_in_ca_white_mobile": 61752,
	"./made_in_ca_white_mobile.svg": 61752,
	"./maple_leaf_white": 10795,
	"./maple_leaf_white.svg": 10795,
	"./misc/question-mark": 75267,
	"./misc/question-mark.png": 75267,
	"./misc/spinner_full": 91919,
	"./misc/spinner_full.gif": 91919,
	"./mothers-delivery": 73778,
	"./mothers-delivery.svg": 73778,
	"./orders/change-order": 68400,
	"./orders/change-order.svg": 68400,
	"./orders/repair": 28940,
	"./orders/repair.svg": 28940,
	"./orders/resize": 22979,
	"./orders/resize.svg": 22979,
	"./orders/return": 55173,
	"./orders/return.svg": 55173,
	"./perks/99dayreturn": 99149,
	"./perks/99dayreturn.svg": 99149,
	"./perks/freegift": 13313,
	"./perks/freegift.svg": 13313,
	"./perks/freeresizing": 4370,
	"./perks/freeresizing.svg": 4370,
	"./perks/freeshipping": 80413,
	"./perks/freeshipping.svg": 80413,
	"./perks/madein": 48355,
	"./perks/madein.svg": 48355,
	"./perks/safe-shopping": 96827,
	"./perks/safe-shopping.svg": 96827,
	"./perks/warranty": 32497,
	"./perks/warranty.svg": 32497,
	"./photo_uploads/URL": 3532,
	"./photo_uploads/URL.svg": 3532,
	"./photo_uploads/delete": 30984,
	"./photo_uploads/delete.svg": 30984,
	"./photo_uploads/down": 74277,
	"./photo_uploads/down.svg": 74277,
	"./photo_uploads/dropbox": 29965,
	"./photo_uploads/dropbox.svg": 29965,
	"./photo_uploads/edit": 22549,
	"./photo_uploads/edit.svg": 22549,
	"./photo_uploads/facebook": 66757,
	"./photo_uploads/facebook.svg": 66757,
	"./photo_uploads/flickr": 70228,
	"./photo_uploads/flickr.svg": 70228,
	"./photo_uploads/googledrive_1x": 69975,
	"./photo_uploads/googledrive_1x.jpg": 69975,
	"./photo_uploads/googledrive_2x": 64002,
	"./photo_uploads/googledrive_2x.jpg": 64002,
	"./photo_uploads/instagram": 11300,
	"./photo_uploads/instagram.jpg": 11300,
	"./photo_uploads/instagram_2x": 37019,
	"./photo_uploads/instagram_2x.jpg": 37019,
	"./photo_uploads/left": 59166,
	"./photo_uploads/left.svg": 59166,
	"./photo_uploads/onclick/delete": 30552,
	"./photo_uploads/onclick/delete.svg": 30552,
	"./photo_uploads/onclick/down": 21397,
	"./photo_uploads/onclick/down.svg": 21397,
	"./photo_uploads/onclick/edit": 92997,
	"./photo_uploads/onclick/edit.svg": 92997,
	"./photo_uploads/onclick/left": 98766,
	"./photo_uploads/onclick/left.svg": 98766,
	"./photo_uploads/onclick/right": 2445,
	"./photo_uploads/onclick/right.svg": 2445,
	"./photo_uploads/onclick/rotate_left": 69440,
	"./photo_uploads/onclick/rotate_left.svg": 69440,
	"./photo_uploads/onclick/rotate_right": 66671,
	"./photo_uploads/onclick/rotate_right.svg": 66671,
	"./photo_uploads/onclick/up": 30458,
	"./photo_uploads/onclick/up.svg": 30458,
	"./photo_uploads/onclick/zoomin": 19657,
	"./photo_uploads/onclick/zoomin.svg": 19657,
	"./photo_uploads/onclick/zoomout": 49112,
	"./photo_uploads/onclick/zoomout.svg": 49112,
	"./photo_uploads/right": 70109,
	"./photo_uploads/right.svg": 70109,
	"./photo_uploads/rotate_left": 85264,
	"./photo_uploads/rotate_left.svg": 85264,
	"./photo_uploads/rotate_right": 88223,
	"./photo_uploads/rotate_right.svg": 88223,
	"./photo_uploads/up": 71146,
	"./photo_uploads/up.svg": 71146,
	"./photo_uploads/upload": 89258,
	"./photo_uploads/upload-arrow": 81022,
	"./photo_uploads/upload-arrow.svg": 81022,
	"./photo_uploads/upload.svg": 89258,
	"./photo_uploads/zoomin": 24569,
	"./photo_uploads/zoomin.svg": 24569,
	"./photo_uploads/zoomout": 49755,
	"./photo_uploads/zoomout.svg": 49755,
	"./quick_ship_green": 99633,
	"./quick_ship_green.svg": 99633,
	"./reseller_ratings": 44281,
	"./reseller_ratings.png": 44281,
	"./resize": 17063,
	"./resize.svg": 17063,
	"./ring-width-icons/10.5mm": 83820,
	"./ring-width-icons/10.5mm.svg": 83820,
	"./ring-width-icons/10mm": 14151,
	"./ring-width-icons/10mm.svg": 14151,
	"./ring-width-icons/11mm": 54402,
	"./ring-width-icons/11mm.svg": 54402,
	"./ring-width-icons/5.5mm": 20278,
	"./ring-width-icons/5.5mm.svg": 20278,
	"./ring-width-icons/5mm": 82653,
	"./ring-width-icons/5mm.svg": 82653,
	"./ring-width-icons/6.5mm": 99441,
	"./ring-width-icons/6.5mm.svg": 99441,
	"./ring-width-icons/6mm": 22518,
	"./ring-width-icons/6mm.svg": 22518,
	"./ring-width-icons/7.5mm": 69840,
	"./ring-width-icons/7.5mm.svg": 69840,
	"./ring-width-icons/7mm": 75963,
	"./ring-width-icons/7mm.svg": 75963,
	"./ring-width-icons/8.5mm": 45243,
	"./ring-width-icons/8.5mm.svg": 45243,
	"./ring-width-icons/8mm": 60780,
	"./ring-width-icons/8mm.svg": 60780,
	"./ring-width-icons/9.5mm": 51250,
	"./ring-width-icons/9.5mm.svg": 51250,
	"./ring-width-icons/9mm": 65977,
	"./ring-width-icons/9mm.svg": 65977,
	"./ring-width-icons/display": 8088,
	"./ring-width-icons/display.svg": 8088,
	"./seals/trustwave_seal": 64646,
	"./seals/trustwave_seal.png": 64646,
	"./search": 63143,
	"./search.svg": 63143,
	"./send-a-hint-icon": 19611,
	"./send-a-hint-icon.svg": 19611,
	"./spinner": 81318,
	"./spinner.gif": 81318,
	"./spinner_2x": 64511,
	"./spinner_2x.gif": 64511,
	"./touch/touch-icon-ipad": 55204,
	"./touch/touch-icon-ipad-retina": 27534,
	"./touch/touch-icon-ipad-retina.png": 27534,
	"./touch/touch-icon-ipad.png": 55204,
	"./touch/touch-icon-iphone": 27167,
	"./touch/touch-icon-iphone-retina": 11503,
	"./touch/touch-icon-iphone-retina.png": 11503,
	"./touch/touch-icon-iphone.png": 27167,
	"./tree": 17904,
	"./tree.svg": 17904,
	"./tree_black": 62951,
	"./tree_black.svg": 62951,
	"./truck": 49724,
	"./truck.svg": 49724,
	"./truck_primary_purple": 32852,
	"./truck_primary_purple.svg": 32852,
	"./upload-arrow": 97164,
	"./upload-arrow.svg": 97164,
	"./whatsapp_blue": 61944,
	"./whatsapp_blue.svg": 61944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68593;